import Icon from '../components/Icon.vue'

Icon.register({
  'sim-card': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M320 0H128L0 128V448C0 483.3 28.7 512 64 512H320C355.3 512 384 483.3 384 448V64C384 28.7 355.3 0 320 0zM160 192H224V256H160V192zM64 224C64 206.3 78.3 192 96 192H128V256H64V224zM128 448H96C78.3 448 64 433.7 64 416V384H128V448zM224 448H160V384H224V448zM320 416C320 433.7 305.7 448 288 448H256V384H320V416zM320 352H64V288H320V352zM320 256H256V192H288C305.7 192 320 206.3 320 224V256z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sim-card.js
// module id = BXgR
// module chunks = 144